import React from "react";
import cx from "classnames";
import "./ErrorMessage.scss";

/**
 *
 * @param {object} props
 * @param {string} [props.additionalText]
 * @param {boolean} [props.dark]
 * @param {string} [props.headingText]
 * @returns {React.ReactElement}
 */
const ErrorMessage = ({
    additionalText = "Contact the organization for support.",
    dark = false,
    headingText = "We're sorry, it looks like something went wrong.",
}) => {
    const errorMessageClasses = cx(
        "error-message",
        dark && "error-message__background--dark",
    );

    return (
        <div className={errorMessageClasses}>
            <h2 className="error-message__heading">{headingText}</h2>
            <p>{additionalText}</p>
        </div>
    );
};

export default ErrorMessage;
